export default __webpack_public_path__ + "static/media/login-icon-dark.53587f05.svg";